import { useContext } from "react";
import { TooltipStyleContext, TooltipStyleContextValue } from "./TooltipStyleContext";

/**
 * Gets the tooltip style context value.
 * @returns The tooltip style context value.
 */
export function useTooltipStyleContext(): TooltipStyleContextValue {
  return useContext(TooltipStyleContext);
}
